import React from "react";
import { LANDING } from "@/constants/testIds";
import { UserPlus, Mail, ShoppingBag, Box, ArrowRight } from "lucide-react";

const STEPS = [
  {
    n: "01",
    Icon: UserPlus,
    title: "Apply",
    desc: "Join the waitlist. Applications are reviewed quietly.",
  },
  {
    n: "02",
    Icon: Mail,
    title: "Get Access",
    desc: "Members receive private launch notification before public.",
  },
  {
    n: "03",
    Icon: ShoppingBag,
    title: "Shop The Drop",
    desc: "Limited quantities. Time-boxed. One per member.",
  },
  {
    n: "04",
    Icon: Box,
    title: "Archive",
    desc: "Sold-out pieces are sealed in The Archive. Never restocked.",
  },
];

export default function HowItWorks() {
  return (
    <section
      data-testid={LANDING.howSection}
      className="relative bg-[hsl(var(--scrm-surface))] border-t hairline"
    >
      <div className="px-6 md:px-10 py-20 md:py-28">
        <div className="flex items-end justify-between flex-col md:flex-row gap-6 mb-14 md:mb-20">
          <div>
            <div className="text-[10px] tracking-eyebrow uppercase text-[hsl(var(--scrm-cream))]/55 mb-4">
              ✦ Protocol
            </div>
            <h2 className="font-display uppercase tracking-mega text-[hsl(var(--scrm-cream))] text-4xl sm:text-5xl md:text-6xl leading-[0.92]">
              How it works.
            </h2>
          </div>
          <p className="font-body text-sm md:text-base text-[hsl(var(--scrm-cream))]/60 max-w-sm">
            Four steps between application and archive. Move with the club, or miss the
            moment.
          </p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-4 gap-px bg-[hsl(var(--scrm-cream))]/8">
          {STEPS.map((s, i) => (
            <li
              key={s.n}
              data-testid={LANDING.howStep(i + 1)}
              className="group relative bg-[hsl(var(--scrm-surface))] p-8 md:p-10 min-h-[280px] flex flex-col justify-between transition-colors duration-500 hover:bg-[hsl(var(--scrm-elevated))]"
            >
              <div className="flex items-start justify-between">
                <span className="step-number text-5xl md:text-6xl">{s.n}</span>
                <s.Icon
                  className="h-5 w-5 text-[hsl(var(--scrm-cream))]/60 group-hover:text-[hsl(var(--scrm-cream))] transition-colors"
                  strokeWidth={1.25}
                />
              </div>

              <div>
                <h3 className="font-display uppercase tracking-[0.06em] text-xl md:text-2xl text-[hsl(var(--scrm-cream))] mb-3">
                  {s.title}
                </h3>
                <p className="font-body text-sm text-[hsl(var(--scrm-cream))]/60 leading-relaxed">
                  {s.desc}
                </p>
              </div>

              {i < STEPS.length - 1 && (
                <ArrowRight
                  className="hidden md:block absolute -right-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-[hsl(var(--scrm-cream))]/30"
                  strokeWidth={1}
                />
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
